import React from 'react';

import classNames from 'classnames';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import voca from 'voca';

import Tooltip from 'components/application/Tooltip';

import { useCurrentActor } from 'components/contexts/CurrentActor';

const indicatorClassNames = {
  ended: 'tw-bg-grey-300',
  future: 'tw-bg-amber-400',
  live: 'tw-bg-green-400',
  noStatus: 'tw-bg-white tw-border-2 tw-border-solid tw-border-grey-300',
  notSet: 'tw-bg-white tw-border-2 tw-border-solid tw-border-grey-300',
};

export default function LifecycleStatusIndicator({ status }) {
  const currentActor = useCurrentActor();

  const { t: i18nT } = useTranslation('components', {
    keyPrefix: 'projects.components.LifecycleStatusIndicator',
  });

  const { t: i18nTProjects } = useTranslation('common', {
    keyPrefix: 'projects',
  });

  if (!status) return null;

  const singularRAMSName = voca.capitalize(
    currentActor.division.attributes.singularRAMSName,
  );

  const tooltip = (() => {
    switch (status) {
      case 'ended':
        return i18nTProjects('ended', {
          interpolation: { escapeValue: false },
          singularRAMSName,
        });
      case 'future':
        return i18nT('tooltip.future', {
          interpolation: { escapeValue: false },
          singularRAMSName,
        });
      case 'live':
        return i18nT('tooltip.live', {
          interpolation: { escapeValue: false },
          singularRAMSName,
        });
      case 'noStatus':
      case 'notSet':
        return i18nTProjects('dateNotSet', {
          interpolation: { escapeValue: false },
          singularRAMSName,
        });
    }
  })();

  return (
    <div className='tooltip-parent tw-flex'>
      <div
        className={classNames(
          'tw-inline-flex tw-h-2.5 tw-w-2.5 tw-rounded-full',
          indicatorClassNames[status],
        )}
      />
      <Tooltip placement='top' tooltip={tooltip} trigger='hover' />
    </div>
  );
}

LifecycleStatusIndicator.propTypes = {
  status: PropTypes.oneOf(['ended', 'future', 'live', 'noStatus', 'notSet']),
};
